<div class="dialog-container">
  <div class="header">
    <div class="title">{{ 'staff.createStaff.title' | translate }}</div>
    <button class="close-icon-btn" (click)="onClose()">
      <app-icon class="close-icon" [icon]="IconName.CLOSE" />
    </button>
  </div>
  <div class="body">
    <form [formGroup]="addStaffForm" id="addStaffForm" (ngSubmit)="onSubmit()">
      <div class="dialog-container__grid">
        <app-input-field
          [label]="'staff.createStaff.firstName.label' | translate"
          [controlId]="'firstName'"
          [placeholder]="'staff.createStaff.firstName.placeholder' | translate"
          [customMessage]="'staff.createStaff.firstName.invalidName' | translate"
          formControlName="firstName"
        />

        <app-input-field
          [label]="'staff.createStaff.lastName.label' | translate"
          [controlId]="'lastName'"
          [placeholder]="'staff.createStaff.lastName.placeholder' | translate"
          [customMessage]="'staff.createStaff.lastName.invalidLastName' | translate"
          formControlName="lastName"
        />

        <app-input-field
          [label]="'staff.createStaff.email.label' | translate"
          [controlId]="'email'"
          [placeholder]="'staff.createStaff.email.placeholder' | translate"
          [customMessage]="'staff.createStaff.email.invalidEmail' | translate"
          formControlName="email"
        />
        <div class="row">
          <app-dropdown-field
            controlId="role"
            [label]="'staff.createStaff.role.label' | translate"
            [placeholder]="'staff.createStaff.role.placeholder' | translate"
            [roles]="roles()"
            [emptyMessage]="'staff.createStaff.emptyError' | translate"
            [invalidMessage]="'staff.createStaff.role.invalidRole' | translate"
            formControlName="role"
          />
        </div>
      </div>
    </form>
  </div>
  <div class="footer">
    <button class="cancel-btn" (click)="onClose()">
      {{ 'staff.createStaff.cancel' | translate }}
    </button>
    <button class="submit-btn" type="submit" form="addStaffForm">
      {{ 'staff.createStaff.add' | translate }}
    </button>
  </div>
</div>
